// extracted by mini-css-extract-plugin
export default {"container":"style_container__nOBFk","header":"style_header__2v6e8","title":"style_title__jnxKp","body":"style_body__dkjNh"};